import { render, staticRenderFns } from "./priceCombinationStep.vue?vue&type=template&id=62ce47bb&scoped=true&"
import script from "./priceCombinationStep.vue?vue&type=script&lang=js&"
export * from "./priceCombinationStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ce47bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62ce47bb')) {
      api.createRecord('62ce47bb', component.options)
    } else {
      api.reload('62ce47bb', component.options)
    }
    module.hot.accept("./priceCombinationStep.vue?vue&type=template&id=62ce47bb&scoped=true&", function () {
      api.rerender('62ce47bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Price/priceCombinationStep.vue"
export default component.exports